import PropTypes from 'prop-types';
import { Typography, makeStyles } from '@material-ui/core';
import classNames from 'classnames';
import {
  ABSENCE_REPORT_BALANCE_ITEMS,
  ABSENCE_REPORT_BALANCE_KEYS,
} from '../../../constants/absence';

const useStyles = makeStyles(({ palette: { primary }, spacing }) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, minmax(0,300px))',
    gap: 16,
    height: 118,
  },
  balanceWrapper: {
    boxSizing: 'border-box',
    backgroundColor: primary.bluish8,
    borderRadius: 8,
    padding: spacing(4),
    height: '100%',
  },
  label: {
    marginBottom: spacing(3),
  },
  valueWrapper: {
    display: 'flex',
    alignItems: 'baseline',
    marginBottom: spacing(2),
  },
  dayUnit: {
    color: primary.bluish4,
    marginLeft: spacing(2),
  },
  subLabel: {
    color: primary.bluish4,
  },
}));

const AbsenceBalanceStats = ({
  className = undefined,
  balance = {},
  translations,
}) => {
  const classes = useStyles();

  return (
    <div className={classNames(classes.root, className)}>
      {ABSENCE_REPORT_BALANCE_ITEMS.map(({ key, value }) => (
        <div key={`balance_stat_${key}`} className={classes.balanceWrapper}>
          <Typography className={classes.label} variant="subtitle1">
            {translations[key]}
          </Typography>
          <div className={classes.valueWrapper}>
            <Typography variant="h3">{balance[value] ?? '-'}</Typography>
            {(balance[value] || balance[value] === 0) && (
              <Typography className={classes.dayUnit} variant="body1">
                {translations.dayUnit}
              </Typography>
            )}
          </div>
          <Typography className={classes.subLabel} variant="subtitle2">
            {translations.totalAcrossTeam}
          </Typography>
        </div>
      ))}
    </div>
  );
};

AbsenceBalanceStats.propTypes = {
  className: PropTypes.string,
  balance: PropTypes.shape({
    [ABSENCE_REPORT_BALANCE_KEYS.AVAILABLE]: PropTypes.number,
    [ABSENCE_REPORT_BALANCE_KEYS.ACCRUED]: PropTypes.number,
    [ABSENCE_REPORT_BALANCE_KEYS.TAKEN]: PropTypes.number,
    [ABSENCE_REPORT_BALANCE_KEYS.SCHEDULED]: PropTypes.number,
  }),
  translations: PropTypes.shape({
    available: PropTypes.string.isRequired,
    accrued: PropTypes.string.isRequired,
    taken: PropTypes.string.isRequired,
    scheduled: PropTypes.string.isRequired,
    totalAcrossTeam: PropTypes.string.isRequired,
    dayUnit: PropTypes.string.isRequired,
  }).isRequired,
};

export default AbsenceBalanceStats;
